// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  getRemoteConfig,
  fetchAndActivate,
  getValue,
} from "firebase/remote-config";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDAQUGUi9xvBN61T7Yr0X_1j0lm8sLD5IY",
  authDomain: "fbtesat.firebaseapp.com",
  projectId: "fbtesat",
  storageBucket: "fbtesat.firebasestorage.app",
  messagingSenderId: "21371840019",
  appId: "1:21371840019:web:1ded19a4a4b76e96cc81e6",
  measurementId: "G-61RVLE0J7J",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const remoteConfig = getRemoteConfig(app);
remoteConfig.settings.minimumFetchIntervalMillis = 3600000;
remoteConfig.defaultConfig = {
  server_url_test: "aplicacao.ivitech.com.br/hfbtesat",
};

export const storage = getStorage(app);

export const activateFirebaseConfig = async (
  suffix: string
): Promise<string> => {
  return new Promise<string>(async (resolve, reject) => {
    try {
      await fetchAndActivate(remoteConfig);

      if (suffix === "dev") {
        const value = getValue(remoteConfig, "server_url_dev");
        resolve(`https://${value.asString()}/api/v2`);
      } else if (suffix === "teste") {
        const value = getValue(remoteConfig, "server_url_test");
        resolve(`https://${value.asString()}/api/v2`);
      } else if (suffix === "local") {
        resolve("http://192.168.3.121:8080/dfbtesat/api/v2");
      } else {
        const value = getValue(remoteConfig, "server_url_prod");
        resolve(`https://${value.asString()}/api/v2`);
      }
    } catch (err) {
      //console.log(err);
      reject({ message: "Network Error" });
    }
  });
};
